//@ts-check

/**
 * @type {import("./types").capitalizeType}
 */
export default (function (str) {
  return str.replace(/(^|\s)\S/g, function (l) {
    return l.toUpperCase();
  });
});